/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Accordion, AccordionItem } from '@heroui/react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../cra/src/styling/breakpointsMinWidth';

const ComponentWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 64px 16px;

  @media ${breakpointsMinWidth.tabletSm} {
    width: 728px;
    padding: 80px 8px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    width: 846px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    width: 950px;
  }
  .faq-title {
    color: #2364eb;
    font-size: 16px;
    font-weight: 500;
  }

  @media (min-width: 1024px) {
    .faq-title {
      font-size: 18px;
    }
  }
`;

const FAQSection = ({ faqs }) => {
  return (
    <ComponentWrapper>
      <Accordion isCompact>
        {faqs.map((faq, index) => (
          <AccordionItem
            key={index}
            aria-label={faq.question}
            title={faq.question}
            classNames={{
              title: 'faq-title',
            }}
          >
            {faq.answerLine}
          </AccordionItem>
        ))}
      </Accordion>
    </ComponentWrapper>
  );
};

export default FAQSection;
